import { graphql, fetchQuery, createOperationDescriptor } from 'relay-runtime';
import getRelayEnvironment from '@atlassian/jira-relay-environment/src/index.tsx';
import rovoDevAgentsUserCheckQuery, {
	type rovoDevAgentsUserCheckQuery as rovoDevAgentsUserCheckQueryType,
	type rovoDevAgentsUserCheckQuery$data as rovoDevAgentsUserCheckQueryData,
} from '@atlassian/jira-relay/src/__generated__/rovoDevAgentsUserCheckQuery.graphql';

export const rovoDevAgentsUserCheck = (
	atlassianAccountId: string,
	cloudId: string,
	isAutodevBetaEnabled: boolean,
): Promise<rovoDevAgentsUserCheckQueryData | undefined> => {
	/* eslint-disable @atlassian/relay/unused-fields */
	const query = graphql`
		query rovoDevAgentsUserCheckQuery(
			$atlassianAccountId: ID!
			$cloudId: ID!
			$isAutodevBetaEnabled: Boolean!
		) {
			devai_rovoDevAgentsUser(atlassianAccountId: $atlassianAccountId, cloudId: $cloudId)
				@required(action: THROW)
				@optIn(to: "DevAiUsers")
				@include(if: $isAutodevBetaEnabled) {
				hasProductAccess
				isAdmin
			}

			jira {
				isRovoEnabled(cloudId: $cloudId)
					@optIn(to: "JiraAtlassianIntelligence")
					@include(if: $isAutodevBetaEnabled)
			}
		}
	`;
	/* eslint-enable @atlassian/relay/unused-fields */

	const variables = {
		atlassianAccountId,
		cloudId,
		isAutodevBetaEnabled,
	};
	const request = fetchQuery<rovoDevAgentsUserCheckQueryType>(
		getRelayEnvironment(),
		query,
		variables,
		{
			fetchPolicy: 'store-or-network',
		},
	);

	/* fetchQuery will NOT retain the data for the query, meaning that it is not guaranteed that the
       data will remain saved in the Relay store at any point after the request completes. We need to
       explicitly retain the operation to ensure it doesn't get deleted. See https://relay.dev/docs/api-reference/fetch-query/#behavior */
	getRelayEnvironment().retain(createOperationDescriptor(rovoDevAgentsUserCheckQuery, variables));

	return request.toPromise();
};
